import { Component, Input, type OnDestroy, type OnInit } from '@angular/core'
import { SharedService } from '../../../../services/shared.service'
import {
  type ReminderChannelDTO, type VehicleReminderDTO, VehicleRemindersService
} from '../../../../services/vehicle-reminders.service'
import { VehicleDTOExtended } from '../../../../services/vehicles.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component'
import { VehicleRemindersFormComponent } from './vehicle-reminders-form/vehicle-reminders-form.component'
@Component({
  selector: 'customer-portal-app-revolution-vehicle-reminders',
  standalone: true,
  templateUrl: './vehicle-reminders.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    SkeletonLoaderComponent,
    VehicleRemindersFormComponent
  ]
})
export class VehicleRemindersComponent implements OnInit, OnDestroy {
  @Input()
  public vehicle: VehicleDTOExtended

  loading = true
  vehicleRemindersOld: VehicleReminderDTO[] = []
  vehicleReminders: VehicleReminderDTO[] = []
  channels: ReminderChannelDTO[] = []

  selectedReminder: VehicleReminderDTO

  sub = {
    vehicleReminders: null,
    updatingVehicleReminders: null,
    onVehicleRemindersLoaded: null,
    channels: null,
    onChannelsLoaded: null,
    onVehicleReminderChanged: null
  }

  loadingVehicleReminders: boolean
  updatingVehicleReminders: boolean
  loadingChannels: boolean

  reminderTypesSVG = {
    'insurance-end-reminder': 'car_return',
    'warranty-end-reminder': 'car_insurance',
    'road-tax-reminder': 'monetization_on',
    'tüv-reminder': 'clipboard_check'
  }

  vehicleReminderTypes: string[]
  constructor (
    private readonly vehicleRemindersService: VehicleRemindersService,
    private readonly sharedService: SharedService
  ) {}

  ngOnInit (): void {
    this.sub.vehicleReminders =
      this.vehicleRemindersService.loading.vehicleReminders.subscribe(
        loading => {
          this.loadingVehicleReminders = loading
          this.setLoading()
        }
      )
    this.sub.updatingVehicleReminders =
      this.vehicleRemindersService.loading.updatingVehicleReminders.subscribe(
        loading => {
          this.updatingVehicleReminders = loading
          this.setLoading()
        }
      )
    this.sub.channels = this.vehicleRemindersService.loading.channels.subscribe(
      loading => {
        this.loadingChannels = loading
        this.setLoading()
      }
    )
    this.sub.onVehicleRemindersLoaded =
      this.vehicleRemindersService.onVehicleRemindersLoaded.subscribe(data => {
        this.vehicleReminders = data
        this.setLoading()
      })
    this.sub.onChannelsLoaded =
      this.vehicleRemindersService.onChannelsLoaded.subscribe(data => {
        this.channels = data
        this.setLoading()
      })
  }

  setLoading (): void {
    this.loading = this.loadingVehicleReminders || this.loadingChannels
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }
}
